import { render, staticRenderFns } from "./PalletErrors.vue?vue&type=template&id=588f5916&scoped=true&"
import script from "./PalletErrors.vue?vue&type=script&lang=js&"
export * from "./PalletErrors.vue?vue&type=script&lang=js&"
import style0 from "./PalletErrors.vue?vue&type=style&index=0&id=588f5916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f5916",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
